import BreedsApi from '../libs/breeds-api';

const breedsApi = new BreedsApi();

export {
  breedsApi as default,
};
